import React from 'react';

import { useParams } from 'react-router-dom';

import { useQueryGetComponent } from 'api/queries/getComponent.query';

import OverlayWithSpinner from 'components/common/OverlayWithSpinner/overlayWithSpinner';
import PageContainer from 'components/common/PageContainer/PageContainer';

import { ConfirmWidgetPage } from 'components/pages/ConfirmWidgetPage/ConfirmWidgetPage';

export interface ConfirmWidgetPageWrapperUrlParams {
    widgetId: string;
}

export const ConfirmWidgetPageWrapper = () => {
    // NOTE: This wrapper component fetches the widget by ID
    // and renders the ConfirmWidgetPage in edit mode once data is loaded.
    const { widgetId } = useParams<ConfirmWidgetPageWrapperUrlParams>();
    const { data: widget, isFetching } = useQueryGetComponent({ componentId: widgetId });

    if (isFetching) {
        return (
            <PageContainer>
                <OverlayWithSpinner />
            </PageContainer>
        );
    }

    if (!widget) {
        return (
            <PageContainer>
                <div>Widget not found.</div>
            </PageContainer>
        );
    }

    return <ConfirmWidgetPage widget={widget} />;
};
